import { Box, Button, Typography } from "@mui/material";
import { Helmet } from "react-helmet";

export default function AcceptInvite() {
  return (
    <Box sx={{ maxWidth: 560, mx: "auto", p: 6, mt: 8 }}>
      <Helmet>
        <title>Orkes Cloud - Invitation retired</title>
      </Helmet>
      <Typography variant="h5" gutterBottom>
        This invitation link is no longer active
      </Typography>
      <Typography paragraph>
        Organizations now add users directly. Ask your organization
        administrator to add you using your sign-in email.
      </Typography>
      <Typography paragraph>
        If you have already been added, sign in to access your organization.
      </Typography>
      <Button variant="contained" href="/">
        Go to sign in
      </Button>
    </Box>
  );
}
